import { type AddressProps } from '@/services/types/mockAddress'

export interface FormatAddressProps {
  address: Omit<AddressProps, 'country'>
  formattedCountry: string
  showZipCode?: boolean
}

export function formatAddress({
  address,
  formattedCountry,
  showZipCode = true,
}: FormatAddressProps): [string, string, string] {
  const { addressLocality, addressRegion, postalCode, streetAddress, streetAddressDetail } = address

  const firstLine = [streetAddress, streetAddressDetail].map((value) => value ?? '').join(' ')
  const secondLine = (
    showZipCode ? [addressLocality, addressRegion, postalCode] : [addressLocality, addressRegion]
  )
    .filter(Boolean)
    .join(', ')
  const thirdLine = formattedCountry ?? ''

  return [firstLine, secondLine, thirdLine]
}
